export const ru = {
    show_email: 'Показать email',
    hide_email: 'Скрыть email',
    failed_to_receive_email: 'Не удалось получить электронную почту сотрудника. Попробуйте ещё раз позже',
};
